import { SET_FILTERS, RESET_FILTERS } from './types';

const initialState = {
  keywords: [],
  disorders: [],
  objectives: [],
  languages: [],
  specialization: [],
  search: null,
  page: 1
};

export const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FILTERS:
      return { ...state, ...action.payload };
    case RESET_FILTERS:
      return initialState;
    default:
      return state;
  }
};
